<p-dialog
  [(visible)]="visible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '500px', height: 'auto' }"
  [contentStyle]="{ overflow: 'visible' }"
  (visibleChange)="visibleChange.emit($event)">

  <!-- HEADER CUSTOMIZADO COM WAVE -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-user-plus" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ tituloDialog }}</h2>
        <p>{{ descricaoDialog }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body">
    <!-- Radio buttons: RUC / CI -->
    <div class="field modo-busca-field">
      <div class="modo-busca-options">
        <p-radioButton
          name="modoBusca"
          value="ruc"
          [(ngModel)]="modoBusca"
          (ngModelChange)="onModoBuscaChange()"
          inputId="modoRuc"
          [label]="'pessoa-adicionar-dialog.labels.ruc' | translate">
        </p-radioButton>
        <p-radioButton
          name="modoBusca"
          value="ci"
          [(ngModel)]="modoBusca"
          (ngModelChange)="onModoBuscaChange()"
          inputId="modoCi"
          [label]="'pessoa-adicionar-dialog.labels.ci' | translate">
        </p-radioButton>
      </div>
    </div>

    <!-- Campo de busca RUC (visivel quando modoBusca === 'ruc') -->
    <app-ruc-busca
      *ngIf="modoBusca === 'ruc'"
      (pessoaVinculada)="onPessoaVinculada($event)"
      (pessoaConfirmada)="onPessoaConfirmada($event)"
      (rucValueChange)="rucBusca = $event"
      (rucLimpo)="onRucLimpo()">
    </app-ruc-busca>

    <!-- Campo de busca CI (visivel quando modoBusca === 'ci') -->
    <div *ngIf="modoBusca === 'ci'" class="field">
      <label for="ciBusca">{{ 'pessoa-adicionar-dialog.labels.ci' | translate }}</label>
      <div class="ci-input-wrapper">
        <input
          id="ciBusca"
          type="text"
          pInputText
          [value]="ciBusca"
          (input)="onCiInput($event)"
          [placeholder]="'pessoa-adicionar-dialog.placeholders.digite_ci' | translate"
          style="width: 100%;"
          maxlength="8"
          inputmode="numeric"
          [class.ng-invalid]="ciErro"
          [class.ng-dirty]="ciErro"
          [class.input-encontrado]="ciEncontrado"
          [attr.aria-describedby]="ciErro ? 'ciErro' : null" />
        <i *ngIf="ciBuscando" class="pi pi-spin pi-spinner ci-spinner-overlay" aria-hidden="true"></i>
        <i *ngIf="!ciBuscando && ciEncontrado" class="pi pi-check-circle ci-check-overlay" style="color: #22c55e;" aria-hidden="true"></i>
      </div>
      <small *ngIf="ciErro" id="ciErro" class="p-error">{{ ciErro }}</small>
    </div>

    <!-- Banner de registro encontrado (CI) -->
    <div *ngIf="modoBusca === 'ci' && ciEncontrado" class="ruc-encontrado-banner">
      <i class="pi pi-info-circle"></i>
      <span>{{ 'pessoa-adicionar-dialog.mensagens.ci_encontrado' | translate }}</span>
    </div>

    <div class="field">
      <label for="nomePessoa">{{ labelNome }} <span class="p-error">*</span></label>
      <input
        id="nomePessoa"
        type="text"
        pInputText
        [(ngModel)]="nome"
        [placeholder]="'pessoa-adicionar-dialog.placeholders.nome_completo' | translate"
        style="width: 100%;"
        [class.input-encontrado]="rucEncontrado || ciEncontrado"
        [class.ng-invalid]="tentouSalvar && !nome"
        [class.ng-dirty]="tentouSalvar && !nome" />
    </div>

    <div class="field">
      <app-phone-input
        [(telefone)]="telefone"
        [(ddi)]="paisSelecionado"
        [label]="('pessoa-adicionar-dialog.labels.ddi' | translate) + ' / ' + ('pessoa-adicionar-dialog.labels.telefone' | translate)"
        [placeholder]="'pessoa-adicionar-dialog.placeholders.telefone' | translate"
        [inputStyleClass]="''">
      </app-phone-input>
    </div>

    <div class="field">
      <label for="cidadePessoa">{{ 'pessoa-adicionar-dialog.labels.cidade' | translate }}</label>
      <p-dropdown
        id="cidadePessoa"
        [options]="cidadeList"
        [(ngModel)]="cidadeSelecionada"
        optionLabel="displayLabel"
        [placeholder]="'pessoa-adicionar-dialog.placeholders.selecione_a_cidade' | translate"
        [filter]="true"
        filterBy="displayLabel,nome,nomeEstado"
        [showClear]="true"
        [loading]="cidadeCarregando"
        [style]="{ width: '100%' }"
        appendTo="body"
        panelStyleClass="dropdown-panel-above-modal">
      </p-dropdown>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" (click)="fechar()" [disabled]="salvando">
      {{ 'pessoa-adicionar-dialog.botoes.fechar' | translate }} (Esc)
    </button>
    <button pButton (click)="submit()" [disabled]="salvando">
      {{ 'pessoa-adicionar-dialog.botoes.guardar' | translate }} (Ctrl+S)
    </button>
  </ng-template>
</p-dialog>
